import { CoreInitiativesLinksByIdName } from './name';
import { coreInitiativesLinksRemoveSyncSlice } from '../remove';
import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteInitiativeLink } from '@api';

export const coreInitiativesLinksByIdDeleteAsyncSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ coreInitiativesLinksRemoveSyncSlice.syncActionCreator ]
	},
	name: CoreInitiativesLinksByIdName,
	receive: false,
	request: true,
	requestHandler: deleteInitiativeLink
});
